export const getItem = async (item_name: string, url: string) => {
  return fetch(
    `${url}/erpnext?doctype=Item&fields=["name","image", "valuation_rate"]&filters=[["name","=","${item_name}"]]&limit=1`
  )
    .then((res) => res.json())
    .then((res) => (res.data?.length ? res.data[0] : null))
}
